import { createSelector } from 'reselect';

const getDarkMode = (state) => {
    const {
        config: {
            enableDarkMode = false
        } = {}     
    } = state;
    return enableDarkMode;
};

export const getDarkModeOverride = createSelector(
    [getDarkMode],
    (darkMode) => 
        darkMode
);
